import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Keyboard, KeyboardStyle } from '@capacitor/keyboard';
import { IS_IOS_APP, IS_MOBILE_APP } from '../capacitor/Constants';
import { getLocalStorageItem, getSystemTheme, isTabletLandscape, withLanguageLocale } from '../Helper';
import { updateStatusBar } from '../capacitor/Helper';

export default function useThemeSwitch(selectedThemeOption, setTheme, userData) {
	const html = document.getElementsByTagName('html')[0];

	const { pathname } = useLocation();
	const isMoreMenu = pathname === withLanguageLocale('/more-menu');

	const { id: userId, theme: userTheme } = userData || {};
	const { selected_theme } = userTheme || {};

	const [firstLoad, setFirstLoad] = useState(false);

	const handleSetTheme = async (newTheme, initialSet) => {
		let nextTheme = newTheme;
		let localTheme = newTheme;

		if (newTheme.startsWith('system')) {
			nextTheme = getSystemTheme();
			localTheme = nextTheme.split('_')?.[1];
		}

		const metaThemeColor = document.querySelector('meta[name="theme-color"]');
		const htmlClasses = html.classList;
		htmlClasses.remove('light-theme', 'dark-theme');
		htmlClasses.add(`${localTheme}-theme`);

		document.documentElement.setAttribute('data-color-scheme', localTheme);
		metaThemeColor?.setAttribute('content', localTheme === 'light' ? '#F2F0F5' : '#240E3E');

		if (initialSet) setTheme(localTheme, userId, nextTheme);

		if (IS_MOBILE_APP) {
			const theme = localTheme === 'light' ? 'Light' : 'Dark';
			const themeKey = isMoreMenu ? 'dark' : localTheme;

			if (IS_IOS_APP) await Keyboard?.setStyle({ style: KeyboardStyle[theme] });
			await updateStatusBar(
				isTabletLandscape() &&
					themeKey === 'light'
					? 'dark'
					: themeKey,
			);
		}
	};

	useEffect(() => {
		const currentTheme = getLocalStorageItem('theme');
		handleSetTheme(currentTheme || 'system_light', true);
		setFirstLoad(true);
	}, []);

	useEffect(() => {
		if (userData.hasOwnProperty('theme')) {
			const currentTheme = getLocalStorageItem('theme');

			if (userTheme && selected_theme && selected_theme !== currentTheme)
				handleSetTheme(
					selected_theme.startsWith('system') ? getSystemTheme() : selected_theme,
					true,
				);
		}

		const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

		const handleChange = (event) => {
			handleSetTheme(`system_${event.matches}`, true);
		};

		darkModeMediaQuery?.addEventListener('change', handleChange);

		return () => {
			darkModeMediaQuery?.removeEventListener('change', handleChange);
		};
	}, [userData]);

	useEffect(() => {
		if (firstLoad && selectedThemeOption) handleSetTheme(selectedThemeOption);
	}, [selectedThemeOption]);
}
